
const vipDomain = 'vip.crttd.com'
const serverUrl = process.env.VUE_APP_SERVER_URL || 'https://kg-api.crttd.com'
const fileDomain = 'https://kg-file.crttd.com'
const offDomain = 'https://www.crttd.com'

const filter = (str) => { // 特殊字符转义
  str += '' // 隐式转换
  str = str.replace(/%/g, '%25')
  str = str.replace(/\+/g, '%2B')
  str = str.replace(/ /g, '%20')
  str = str.replace(/\//g, '%2F')
  str = str.replace(/\?/g, '%3F')
  str = str.replace(/&/g, '%26')
  // eslint-disable-next-line no-useless-escape
  str = str.replace(/\=/g, '%3D')
  str = str.replace(/#/g, '%23')
  return str
}
export const formateObjToParamStr = (paramObj) => {
  const sdata = []
  for (const attr in paramObj) {
    sdata.push(`${attr}=${filter(paramObj[attr])}`)
  }
  return sdata.join('&')
}

export { serverUrl, fileDomain, offDomain, vipDomain }
